import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import axios from 'axios';
// import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
// import FormDialog from '../../../../components/table/FormDialog';
import { CommonConfig } from '../../config/common-config';
import ServiceLayout from '../../modules/invoices/common/serviceLayout';
import ServiceTable from '../services/view/Table/table';
import '../../modules/services/servicestyles.css';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    container: {
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginBottom: theme.spacing(1),
    },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const UltimateOpenService = (props) => {
    const classes = useStyles();

    const [searchQuery, setSearchQuery] = useState('');
    const [ultimateRows, setUltimateOpenService] = useState([]);
    const [AllImcs, setAllImcs] = useState([]);
    const [selectedImc, setselectedImc] = useState('');
    const [openBox, setOpenBox] = useState(false);
    // const [deleteMsg, setDeleteMsg] = useState('');
    const vertical = 'top';
    const horizontal = 'center';
    // const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    // const dbname = tennantDetails.tennantName;
    //console.log("dbname", dbname);

    //console.log( "Ultimate Rows" ,ultimateRows);
    // Token Generation

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;

    // Headcells

    const headcells = [
        { id: 'serviceId', label: 'Service ID' },
        { id: 'clientId', label: 'Client id' },
        { id: 'clientType', label: 'Client type' },
        { id: 'servicetypeId', label: 'Service type', isConcat: 'true', concatElem: ['servicetypeText'] },
        { id: 'serviceYear', label: 'Year' },
        { id: 'startDate', label: 'Start date' },
        { id: 'statusId', label: 'Current status' },
    ];

    // const history = useHistory();

    // to set the Rows by default
    const getCandidates = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/getservice-byemployeeid/${selectedImc}?page=0&size=1000&sort=serviceId,desc`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                //console.log("response", response.data);
                setUltimateOpenService(response.data.content);
            })
            .catch((error) => {
                //console.log(error);
            });
    };

    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients`,{
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => setAllImcs(response.data.content))
            .catch((error) => {
                //console.log(error);
            });
        getCandidates();
    }, [userToken]);

    const setImc = (e) => {
        setselectedImc(e.target.value);
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/getservice-byemployeeid/${e.target.value}?page=0&size=1000&sort=serviceId,desc`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setUltimateOpenService(response.data.content);
                //console.log("TEST",response.data.content);
            })
            .catch((error) => {
                //console.log(error.response.data);
                // if (error.response.data) {
                //     setTotalReactPackages([]);
                // }
            });
    };

    const allImcsOptions = (vv) => {
        const OptionList = vv.map((data) => (
            <option value={data.dbName} key={data.dbName}>
                {data.dbName}
            </option>
        ));
        return OptionList;
    };
    const handleClose = () => {
        setOpenBox(false);
    };

    // handleClickonParticularRow

    const handleClickRow = () => {
        //console.log("Click on Particular Row")
    };
    // Delete Row

    // const handleDelete = (row, data) => {
    //     //console.log('deleted Row', row);
    //     //console.log('comments Row', data);

    //     if (row.serviceId) {
    //         axios
    //             .delete(`${CommonConfig.dev.baseUrl}/api/auth/createservice-employee/${selectedImc}/${row.serviceId}`, { data })
    //             .then((response) => {
    //                 //console.log("response", response.data);
    //                 setDeleteService(response.data);
    //                 props.history.push('/menu/closedservice');
    //                 setDeleteMsg('record successfully deleted');
    //                 setOpenBox(true);
    //             })
    //             .catch((error) => {
    //                 if (error) {
    //                     // setShowBtnLoader(false);
    //                     const err = error.response.data;
    //                     //console.log('error:', err);
    //                     // setErrormsg(err.message);
    //                 }
    //             });
    //     }
    // };

    // search Query
    const handleSearchQuery = (searchData) => {
        //console.log(searchData);
        setSearchQuery(searchData);
    };

    // Filtered Row based on search
    const filteredRow = searchQuery
        ? ultimateRows.filter((row) => {
              const query = searchQuery.toLowerCase().trim();
              //   ////console.log(Object.keys(row) ,"Keys of ROW**** object.keys()");
              return headcells
                  .map((col) => col.id)
                  .some((key) => {
                      //console.log(row[key],"Value of ROW****row[key]");
                      return row[key].toString().toLowerCase().includes(query);
                  });
          })
        : ultimateRows;

    return (
        <>
            <div className={classes.root}>
                <div className="itec-textboxes">
                    Select IMC
                    <select className="intclientName intSelect" name="intclientName" onChange={setImc} value={selectedImc}>
                        <option value="" selected disabled hidden>
                            Select IMC
                        </option>
                        {allImcsOptions(AllImcs)}
                    </select>
                </div>

                <ServiceLayout
                    title="Ultimate Open Services"
                    searchQuery={searchQuery}
                    onChange={handleSearchQuery}
                    className={classes}
                    service="ultimateopen"
                >
                    {filteredRow.length === 0 && <span style={{ fontSize: '14px', fontWeight: '700' }}>No records found to display!</span>}
                    <ServiceTable
                        headcells={headcells}
                        rows={filteredRow}
                        pageName="ultimateservice"
                        service="ultimateopen"
                        handleClickRow={handleClickRow}
                    />
                </ServiceLayout>
            </div>
        </>
    );
};

export default UltimateOpenService;
